const Status = {

  Initial: "Initial",
  
  AuthRequired: "AuthRequired",
  AuthProvided: "AuthProvided",
  AuthSuccess: "AuthSuccess",
  AuthError: "AuthError",
  AuthWaiting: "AuthWaiting",

  Joined: "Joined",
  Loading: "Loading",
  Error: "Error",

  WaitingForCompletion: "WaitingForCompletion",
  Review: "Review",
  LiveResults: "LiveResults",

  Ended: "Ended"
};

export default Status;